export const mark = [
        { value: 'Buick', label: 'Buick' },
        { value: 'Volvo', label: 'Volvo' },
        { value: 'Subaru', label: 'Subaru' },
        { value: 'Hummer', label: 'Hummer' },
        { value: 'Mitsubishi', label: 'Mitsubishi' },
        { value: 'Nissan', label: 'Nissan' },
        { value: 'Lincoln', label: 'Lincoln' },
        { value: 'GMC', label: 'GMC' },
        { value: 'Hyundai', label: 'Hyundai' },
        { value: 'Mini', label: 'Mini' },
        { value: 'Bentley', label: 'Bentley' },
        { value: 'Mercedes-Benz', label: 'Mercedes-Benz' },
        { value: 'Aston Martin', label: 'Aston Martin' },
        { value: 'Pontiac', label: 'Pontiac' },
        { value: 'Lamborghini', label: 'Lamborghini' },
        { value: 'Audi', label: 'Audi' },
        { value: 'BMW', label: 'BMW' },
        { value: 'Chevrolet', label: 'Chevrolet' },
        { value: 'Chrysler', label: 'Chrysler' },
        { value: 'Kia', label: 'Kia' },
        { value: 'Land Rover', label: 'Land Rover' },                
];

export const price =[
     { value: 20, label: '20' },
     { value: 25, label: '25' },
     { value: 40, label: '40' },
     { value: 55, label: '55' },
     { value: 60, label: '60' },
     { value: 75, label: '75' },
     { value: 80, label: '80' },
     { value: 95, label: '95' },
     { value: 100, label: '100' },
     { value: 115, label: '115' },
     { value: 120, label: '120' },
     { value: 135, label: '135' },
     { value: 140, label: '140' },
     { value: 155, label: '155' },

]